import Vue from "vue";
Vue.component("advanced-filters-vue", {
  mounted() {
    const dateFrom = this.$el.querySelectorAll('.advanced-filters__content--year--filters .from .dropdown-list li');
    const dateTo = this.$el.querySelectorAll('.advanced-filters__content--year--filters .to .dropdown-list li');

    dateFrom.forEach(item => {
      item.addEventListener('click', function() {
        dateFrom.forEach(li => li.classList.remove('selected-date'));
        this.classList.add('selected-date');
      });
    });
    dateTo.forEach(item => {
      item.addEventListener('click', function() {
        dateTo.forEach(li => li.classList.remove('selected-date'));
        this.classList.add('selected-date');
      });
    });

    function resetFormInputs() {
      resetInput(".author-search-bar__input input");
      resetInput(".journal-search-bar__input input");
      resetCheckbox(".facets-checkbox");
      resetCrossBtn(".searchPill__cross-button")
    }

    function resetInput(selector) {
      const inputElement = document.querySelector(selector);
      inputElement.value = "";
    }

    function resetCheckbox(id) {
      const checkbox = document.querySelector(id);
      checkbox.checked = false;
    }

    function resetCrossBtn(selector) {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.classList.add('searchPill__cross-button-disable');
      });

    }

    function setupDropdownInteraction(triggerSelector, dropdownSelector) {
      const triggerElement = document.querySelector(triggerSelector);
      const dropdownElement = document.querySelector(dropdownSelector);
      const listItems = dropdownElement.querySelectorAll('li');

      function resetDropdown() {
        triggerElement.textContent = '';
      }

      resetButton.addEventListener('click', resetDropdown);
      cancelButton.addEventListener('click', resetDropdown);
      crossButton.addEventListener('click', resetDropdown);

      listItems.forEach((li) => {
        li.addEventListener('click', function() {
          triggerElement.textContent = li.textContent;
        });
      });
    }

    const resetButton = document.querySelector(".btn_reset_filters");
    const cancelButton = document.querySelector(".cancel-btn");
    const crossButton = document.querySelector(".advanced-filters-close-btn");

    resetButton.addEventListener("click", resetFormInputs);
    cancelButton.addEventListener("click", resetFormInputs);
    crossButton.addEventListener("click", resetFormInputs);

    setupDropdownInteraction('.advanced-filters__content--year--filters .from .dropdown-trigger span', '.advanced-filters__content--year--filters .from .dropdown-list');
    setupDropdownInteraction('.advanced-filters__content--year--filters .to .dropdown-trigger span', '.advanced-filters__content--year--filters .to .dropdown-list');

    // add tabindex to the dropdown items for web accessibility
    var listElements = document.querySelectorAll(".advanced-filters__content--year--filters .dropdown-list li");
    var buttonElements = document.querySelectorAll(".advanced-filters__content--year--filters .dropdown-list li button");
    buttonElements.forEach(function(button) {
      button.setAttribute("tabindex", "-1");
    });
    listElements.forEach(function(item) {
      item.setAttribute("tabindex", "0");
    });
  }
});
